<template>
    <div>
      <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <Toolbar class="mb-1">
        
            <template v-slot:start>
                <!-- {{groupdata.stops_details}} -->
                <Button
                
                  icon="pi pi-plus"
                  
                  @click="openNew"
                />
            </template>
            <template v-slot:end>
                <!-- <FileUpload
                mode="basic"
                accept="image/*"
                :maxFileSize="1000000"
                label="Import"
                chooseLabel="Import"
                class="mr-2 inline-block"
              /> -->
            </template>
        </Toolbar>
    <div class="" style="height:600px;overflow:scroll">
    
		<div class="col-12 lg:col-6 xl:col-12"  v-for="(data,key) in groupdatas" :key="key" >
			<!-- <div  > -->
                <br>
			<div class="card mb-0" style="color:white;background-color:#173EA3;font-size:12px;line-height:0.9" >
				
				<div class="grid">
					<div class="col-2 md:col-3">
						<Button
                icon="pi pi-bookmark"
                class="p-button-rounded p-button-primary mt-2"
                v-tooltip.bottom="'QR Code'"
                v-if="data.status=='Active' || data.status=='active'"
                @click="showQr(data)"
              />&nbsp;
              <Button
                  icon="pi pi-trash"
                  title="Edit Group"
                  class="p-button-rounded p-button-danger mr-2"
                  v-if="data.status=='Active'"
                  @click="confirmDeleteProduct(data,key)"
                />
					</div>
					<div class="grid col-4 md:col-9">
            <div class="col-6 md:col-6">
							<span>Status : </span>
              
              <span style="text-align:right" v-if="data.status=='Active' ||data.status=='active'"><badge :value=data.status severity="success"></badge></span>
              <span style="text-align:right" v-else-if="data.status=='InActive' ||data.status=='In Active'"><badge :value=data.status severity="warning"></badge></span>
              <span style="text-align:right" v-else-if="data.status=='Delete' ||data.status=='Deleted'"><badge :value=data.status severity="danger"></badge></span>
              <span style="text-align:right" v-else>-</span>
						</div>
            <div class="col-6 md:col-6">
							
						</div>            
						<div class="col-6 md:col-6">
							<span>Stop Name : </span><span style="text-align:right"><b>{{data.stop_name}}</b></span>
						</div>
                        <div class="col-6 md:col-6">
							<span>Stop : </span><span style="text-align:right"><b>{{data.location?data.location.Label:''}}</b></span>
						</div>
                        <div class="col-6 md:col-6">
							<span>Pincode : </span><span style="text-align:right"><b>{{data.location?data.location.PostalCode:''}}</b></span>
						</div>
                        <div class="col-6 md:col-6">
							<span>region : </span><span style="text-align:right"><b>{{data.location?data.location.Region:''}}</b></span>
						</div>
            <div class="col-6 md:col-6">
							<span>Stop Type : </span><span style="text-align:right"><b>{{data.stop_type_name?data.stop_type_name:''}}</b></span>
						</div>
            <div class="col-6 md:col-6">
							<span>Stop Subtype : </span><span style="text-align:right"><b>{{data.stop_subtype_name?data.stop_subtype_name:''}}</b></span>
						</div>
					</div>
						
				</div>
				<!-- <span class="text-green-500 font-medium">24 new </span>
				<span class="">since last visit</span> -->
			</div>
			<!-- </div> -->
		
		</div>
		
		<div class="col-12" v-if="groupdatas==[]  " style="text-align:left">
            <br>	
			Data Not Found
		</div>
    </div>
    <Dialog header="Add Stop" v-model:visible="productDialog" :breakpoints="{'960px': '75vw'}" :style="{width: '60vw'}" :modal="true">
	    
        <div class="col-12">
              <div class="card">
                <div class="p-fluid formgrid grid">
                    <div class="field col-12 md:col-12">
                    <label for="stop_name">Stop Name</label>
                    <InputText
                      id="stop_name"
                      type="text"
                      v-model.trim="stop_name"
                      required="true"
                      onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                      (event.charCode >= 97 && event.charCode <= 122) || 
                      event.charCode == 32"
                      autofocus
                      :class="{ 'p-invalid': submitted && !stop_name }"
                    />
                  </div>
                    <div class="field col-12 md:col-12">
                    <label for="startpoint">Stop</label>
                   
                    <Dropdown 
                    @change="get_location"
                    v-model="pick_search" 
                    :options="pick_dropdown" 
                    optionLabel="name" 
                    filter 
                    @filter="dropdown_list"
                    placeholder="Select Stops" 
                    >
            <template #value="slotProps">
              <div class="country-item country-item-value" v-if="slotProps.value">
                <div>{{slotProps.value.name}}</div>
              </div>
                <span v-else>
                  {{slotProps.placeholder}}
                </span>
            </template>
            <template #option="slotProps">
              <span>{{slotProps.option.name}}</span>
            </template>
            
          </Dropdown>
                    
                  </div>
                  <div class="field col-12 md:col-12">
                    <label for="sequence_number">Sequence Number</label>
                    <InputText
                      id="sequence_number"
                      type="number"
                      v-model.trim="sequence_number"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !sequence_number }"
                    />
                  </div>
                  <div class="field col-12 md:col-12">
                    <label for="sequence_number">Stop Type</label>
                    <Dropdown 
                     
                      id="type" 
                      v-model="stop_type_dropdownItem" 
                      :options="stop_type_dropdownItems" 
                       optionLabel="name" 
                        
                      filter
                      >
                    </Dropdown>
                  </div>
                  <div class="field col-12 md:col-12">
                    <label for="sequence_number">Stop Sub-Type</label>
                    <Dropdown 
                     
                      id="sub_type" 
                      v-model="stop_subtype_dropdownItem" 
                      :options="stop_subtype_dropdownItems" 
                       optionLabel="name"  
                       
                      filter
                      >
                    </Dropdown>
                  </div>
                  <div class="field col-12 md:col-12">
                    <label for="dust_bin_size">Dust bin size(Liter)</label>
                    <InputText
                      id="dust_bin_size"
                      type="number"
                      v-model.trim="dust_bin_size"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !dust_bin_size }"
                    />
                  </div>
                </div>
                  </div>
                  </div>
                
        
        <template #footer>
		<Button label="ADD" @click="submit_details"  class="p-button-success"   style="margin-left: 5%;"/>&nbsp;
    <Button
              label="Cancel"
              
              class="p-button-danger "
             @click="refresh"
           
            />
		</template>
	</Dialog>


    <Dialog
            v-model:visible="deleteProductDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="flex align-items-center justify-content-center">
              <i
                class="pi pi-exclamation-triangle mr-3"
                style="font-size: 2rem"
              />
              <span
                >Are you sure you want to delete stop ?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteProductDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deletestop"
              />
            </template>
          </Dialog>
          <Dialog
          v-model:visible="qrCodetDialog"
          :style="{ width: '450px' }"
          header="QR Code"
          :modal="true"
        >
        <div style="text-align:right">
          <Button  icon="pi pi-print" @click="printQr()" class="p-button-rounded p-button-info mr-2 mb-2" />
          <Button  icon="pi pi-download" @click="downloadQr()" class="p-button-rounded p-button-info mr-2 mb-2" />
        </div>
				<br>
        <div>
              <qrcode-vue id="qrprint" type="image/png" style="width:100%"  :value="qrcodevalue" size="450" level="H" />
        </div>
        </Dialog>

          
</div>
</template>

<script>
import apis from "@/apis";
import ProductService from "../../service/ProductService";
import QrcodeVue from 'qrcode.vue'
import { FilterMatchMode } from "primevue/api";
import readXlsxFile from 'read-excel-file'
import { stringify } from "qs";


export default {
  data() {
    return {
      get_stop_name:'',
      stop_type_dropdownItems: [],
      stop_type_dropdownItem: null,
      stop_subtype_dropdownItems: [],
      stop_subtype_dropdownItem: null,
      dust_bin_size:'',
        deleteProductDialog: false,
        delete_data:{},
        delete_data_index:'',
      file:[],
      limit: 10,
      filters: {},
      offset: 1,
      page_no: 1,
      list:[],
      stop_name:"",
      sequence_number:"",
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,

      productDialog: false,
      table_data: [],
      place_details: "",
      pick_dropdown: [],
      pick_search: "",
      pick_search_array:[],
      pick_dropdown_array:[],

      name: "",
      status: "",
      location: "",
      mobile_number: "",
      parent_mobile_number:"",

      products: [],
      userlist:[],

      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" }
      ],
      selectstatus: { name: "Active", value: "Active" },

      productService: null,
      groupdatas:[],
      qrCodetDialog:false,
      qrcodevalue:"123444",
    };
  },
  props: ["group_id","groupdata"],
  methods: {
    refresh()
    {
      this.stop_name='';
      this.pick_search='';
      this.sequence_number='';
      this.stop_type_dropdownItem='';
      this.stop_subtype_dropdownItem='';
      this.dust_bin_size='';

    },
    async downloadQr()
    {
      var canvas = await document.getElementById("qrprint");
      var anchor = document.createElement("a");
      anchor.href = canvas.toDataURL("image/png");
      anchor.download = "QrIMAGE.PNG";
      anchor.click();
    },
    async printQr()
    {
         var dataUrl = await document.getElementById('qrprint').toDataURL(); //attempt to save base64 string to server using this var  
    var windowContent = await '<!DOCTYPE html>';
    windowContent += await '<html>'
    windowContent += await '<head><title>'+this.groupdata.name+'('+this.get_stop_name+')</title></head>';
    windowContent +=await '<body>'
    windowContent +=await '<h4> Route Name: '+this.groupdata.name+'</h4>';
    windowContent +=await '<h4> Stop Name: '+this.get_stop_name+'</h4><br>';
    windowContent += await '<img src="' + dataUrl + '">';
    windowContent +=await '</body>';
    windowContent +=await '</html>';
    var printWin = window.open('','','width=900,height=600,align=center');
    // alert(windowContent);
    await printWin.document.open();
    await printWin.document.write(await windowContent);
    printWin.document.close();
    printWin.focus();
    printWin.print();
    // printWin.close();
    },
    showQr(product) {
      this.qrcodevalue=product.uicode;
      this.get_stop_name=product.stop_name;
      this.qrCodetDialog=true;
      
    },
    get_location()
      { 
        this.place_details='';
        var data = { PlaceId:this.pick_search.value};
        var promise = apis.geocodelocationdetails(data);
        promise.then((response) => {
          if (response.data.result) 
          {
            this.place_details=response.data.result[0];
          }
          
          
        });

      },
       dropdown_list(search)
      { 
       var data = { search:search.value};
        var promise = apis.geocodelats(data);
        promise.then((response) => {
          this.pick_dropdown=[];
          var temp=response.data.result;
          for (let a = 0; a < temp.length; a++) {
            this.pick_dropdown.push( { name: temp[a].Text, value: temp[a].PlaceId });
            
          }
        });
      },
    
    isNumberKey(evt) {
            evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }

  },
    fileuploaduser(event)
    {
      // alert("here");
      console.log(event);
      const input = this.$refs.fileupload1;
      // console.log(input);
      if(input.files[0].name.slice((Math.max(0, input.files[0].name.lastIndexOf(".")) || Infinity) + 1)=='xlsx')
      {
        readXlsxFile(input.files[0]).then((rows)=>{
          for(var i=1;i<rows.length;i++)
          {
            this.products.push({
        sr_no:this.products.length+1,
        name: rows[i][0],
        mobile_number: rows[i][1],
        status: "Active",
        location: "",
        _id:'0'    
        });
          }
      })
      }
      else
      {
        alert("Please select valid file");
      }
    },
    onUpload() {
				// alert(123);
				this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
			},
    getgroupstopList()
    { this.groupdatas=[];
      var data = {
          limit: 1,
          page_no: 1,
          count: false,
          _id: this.groupdata._id
  
        };
        this.isLoadingModel = true;
        var promise = apis.group_stop_list(data);
        promise.then((response) => {
          this.isLoadingModel = false;
        
          this.groupdatas = response.data.data;
         
        
          
        });


    },
    checkName(str)
    {
      if(/^[a-zA-Z ]*$/.test(str) == false)
      {
        return str;
      }
      else
      {
        return "";
      }
    },
    checkMobile(str)
    {
      if(/^[0-9]*$/.test(str) == false || str.length !=10)
      {
        return str;
      }
      else
      {
        return "";
      }
    },
    submit_details()
    { 
      
      if (!this.stop_name) 
        {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Stop Name",
            life: 3000,
          });
          return false;
        }
        if (this.place_details==undefined || this.place_details==null || this.place_details==[]) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Stop point",
            life: 3000,
          });
          return false;
        }

        if (!this.sequence_number) 
        {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Sequence Number",
            life: 3000,
          });
          return false;
        }
        if (this.stop_type_dropdownItem==undefined || this.stop_type_dropdownItem==null || this.stop_type_dropdownItem==[]) 
        {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Stop Type",
            life: 3000,
          });
          return false;
        }
       
        if (this.stop_subtype_dropdownItem==undefined || this.stop_subtype_dropdownItem==null || this.stop_subtype_dropdownItem==[]) 
        {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Stop Sub_Type",
            life: 3000,
          });
          return false;
        }
        if (this.dust_bin_size==undefined || this.dust_bin_size==null || this.dust_bin_size==[]) 
        {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter DustBin Size",
            life: 3000,
          });
          return false;
        }
        
        var Details={ 
                      stop_name:this.stop_name,
                      location:this.place_details,
                      sequence_number:this.sequence_number,
                      stop_type_id:this.stop_type_dropdownItem.value,
                      stop_subtype_id:this.stop_subtype_dropdownItem.value,
                      dustbin_size:this.dust_bin_size
                    
                    };
      var data = {
          
          "_id":this.group_id,
          "stop_details":Details,
          "updated_by":localStorage.getItem("id"),
          "stop_name":this.stop_name
          };

          
          this.isLoadingModel = true;
          var promise = apis.add_group_stops(data);
          promise
            .then((responseapi) => {
              this.$swal(responseapi.data.message);
              this.isLoadingModel = false;
              this.productDialog = false;
              this.getgroupstopList();
            })
            .catch((error) => {
              //console.log(error);
              this.$swal.fire(error.response.data);
              this.isLoadingModel = false;
              this.productDialog = false;
              this.getgroupstopList();
  
              
              
            });



    },
    confirmDeleteProduct(data,key) 
      {
        this.delete_data={};
        this.delete_data_index='';
        this.delete_data=data;
        this.delete_data_index=key;
        this.deleteProductDialog = true;
      },
      deletestop() {
        if (this.group_id) 
        {
          var data = {
            _id: this.group_id,
            details:this.delete_data,
            index:this.delete_data_index,
            updated_by:1

          };
         
          this.isLoadingModel = true;
          var promise = apis.delete_group_stops(data);
          promise.then((responseapi) => {
            this.isLoadingModel = false;
            if (responseapi.data.status == true) {
              // this.hideDialog1();
              this.deleteProductDialog = false;
              this.$swal(responseapi.data.message);
              this.getgroupstopList();
              
            } else {
              this.$swal("error to Delete Stop");
              this.getgroupstopList();
            }
          });
        }
      },
    reset_details() {
      this.selectstatus = { name: "Active", value: "Active" };
      this.status = "";
      this.name = "";
      this.mobile_number = "";
      this.sequence_number="";
      this.stop_name="";
    },
    change_status() {
      this.status = this.selectstatus.value;
    },
    async adduser() {
      
    this.change_status();
      if (!this.name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter  Name",
          life: 3000
        });
        return false;
      }
      if (!this.mobile_number) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter  Mobile number",
          life: 3000
        });
        return false;
      }
      if (this.mobile_number.length!=10) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter valid Mobile number",
          life: 3000
        });
        return false;
      }
      if (this.group_type=='School' && this.parent_mobile_number.length!=10) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter valid Parent Mobile number",
          life: 3000
        });
        return false;
      }
      if (!this.status) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000
        });
        return false;
      }
      if (
        this.location == undefined ||
        this.location == null ||
        this.location == []
      ) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Location",
          life: 3000
        });
        return false;
      }
      var data = {
        sr_no:this.products.length+1,
        name: this.name,
        mobile_number: this.mobile_number,
        parent_mobile_number:this.parent_mobile_number,
        Class:this.Class,
        standard:this.standard,
        roll_no:this.roll_no,
        status: this.status,
        location: this.location,
        _id:'0'
      };
      // this.pick_dropdown_array.push(this.name+this.mobile_number);
      this.pick_search_array[this.name+this.mobile_number]=this.pick_search;
      
      this.products.push(data);
      await this.reset_details();
    },
    
    get_stop_type()
    {
      this.loading = true;
      var data = {
        client_id: localStorage.getItem("client_id"),
        count: false,
        status:"Active"
      };
      var promise = apis.getstoptype(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x]._id,
            });
          }
          this.stop_type_dropdownItem = null;
          this.stop_type_dropdownItems = temp_data;
        }
      });
    
    },
    get_stop_subtype()
    {
        this.loading = true;
      var data = {
        client_id: localStorage.getItem("client_id"),
        count: false,
        status:"Active"
      };
      var promise = apis.getstopsubtype(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x]._id,
            });
          }
          this.stop_subtype_dropdownItem = null;
          this.stop_subtype_dropdownItems = temp_data;
        }
      });
    },
    openNew() {

      this.reset_details();
      this.product = {};
      this.products = [];
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    D_M_Y_formatDate(date_parm) {
      if (date_parm) {
        let date = new Date(date_parm);
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        let yyyy = date.getFullYear();
        let new_date = dd + "-" + mm + "-" + yyyy;
        // alert(dd)
        if (dd.toString() != "NaN") {
          //this.receipt_new_date = new_date;
          return new_date;
        } else {
          return date_parm;
        }
      }
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      };
    }
  },
  watch:
  {
    list:
    {
           
      handler(newValue, oldValue) {
              this.userlist=this.list;
        
      }

    }
  },
  async mounted() {
    // alert('here');
    // this.userlist=this.list;
     this.getgroupstopList();
     await this.get_stop_type();
     await this.get_stop_subtype();
  },
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    // this.getgroupstopList();
  },
  components: {QrcodeVue},
};
</script>